import { ethers } from 'ethers';

export const encodeProofPacked = (data) => {
  const packed = ethers.solidityPacked(
    ["bytes32", "bytes32", "uint256", "int256", "int256", "string", "string", "string"],
    [
      ethers.keccak256(ethers.toUtf8Bytes(data.videoFrameHash)),
      ethers.keccak256(ethers.toUtf8Bytes(data.audioSampleHash)),
      data.timestamp,
      Math.floor(data.latitude * 1e6),
      Math.floor(data.longitude * 1e6),
      data.deviceFingerprint,
      data.videoCID,
      data.audioCID || ""
    ]
  );
  return ethers.keccak256(packed);
};
